<div class="desktop">
  @for (tab of tabs; track tab; let i = $index) {
    <button
      class="desktop-tab-button"
      [class.desktop-tab-selected]="selectedTab === tab"
      [class.border-right]="
        (i === 1 || i === 2) &&
        (selectedTab === ProjectTaskDialogTabs.Details || selectedTab === ProjectTaskDialogTabs.Schedule)
      "
      [class.border-left]="
        (i === 1 || i === 2) &&
        (selectedTab === ProjectTaskDialogTabs.Subtasks || selectedTab === ProjectTaskDialogTabs.Triggers)
      "
      (click)="onTabClick(tab)"
      [attr.aria-label]="'Switch to ' + tab + ' tab'"
      type="button"
    >
      {{ tab | titlecase }}
      @if (shouldShowCount(tab)) {
        <div class="tab-count-container">
          {{ getTabCount(tab) }}
        </div>
      }
    </button>
  }
</div>

<div class="mobile">
  @for (tab of tabs; track tab) {
    <button
      class="mobile-tab-button"
      [class.mobile-tab-selected]="selectedTab === tab"
      (click)="onTabClick(tab)"
      [attr.aria-label]="'Switch to ' + tab + ' tab'"
      type="button"
    >
      {{ tab | titlecase }}
    </button>
  }
</div>
